import React from 'react';
import { GdprComponentSe } from '@gjensidige/gdpr-component-se';
import { Button, Title, TitleProps, Text } from '@gjensidige/builders-components';
import { resolveCDNDir } from "@gjensidige/se-content-helpers";

import './WelcomeBack.scss';
import classNames from 'classnames';
interface WelcomeBackProps {
  welcomeMessage: {
    header: string;
    message: string;
  };
  criticalButtonLabel: string;
  criticalButtonAction: () => void;
}
export const WelcomeBack: React.FC<WelcomeBackProps> = (
  props: WelcomeBackProps
) => {
  const bankIdIcon = `${resolveCDNDir()}images/BankID_nopadding_simple.svg`
  return (
    <div className="welcome-back-wrapper mt-md-5 mt-3">
      <div className="welcome-message-wrapper">
        <Title as={'h1' as TitleProps['as']} size="4" className="message-header">{props.welcomeMessage.header}</Title>
        <Text size="body" className="mt-2">{props.welcomeMessage.message}</Text>
      </div>
      <Button
        fill
        className="login-bankid-btn mb-2 mt-5"
        size="md"
        variant="primary"
        onClick={props.criticalButtonAction}
        icon={<img src={bankIdIcon} className='bank-id-icon' alt="bank id icon" data-testid="bank-id-icon-desktop" />}
      >
        {props.criticalButtonLabel}
      </Button>
      <Text size='body'>
        <GdprComponentSe />
      </Text>
    </div>
  );
};
